import { DsRadioGroupOption } from '@design-system/ds-radio-group/interfaces/ds-radio-group-option.interface';

/** Dialog width for the add/edit customer modal. */
export const CUSTOMER_EDIT_MODAL_WIDTH = '80rem';

/** Modal header used for the add mode. */
export const ADD_CUSTOMER_HEADER = 'Add Customer';

/** Modal header used for the edit mode. */
export const EDIT_CUSTOMER_HEADER = 'Edit Customer';

/** Accepts either a formatted `(XXX) XXX-XXXX` number or 10 raw digits. */
export const CUSTOMER_PHONE_PATTERN = /^\(\d{3}\) \d{3}-\d{4}$|^\d{10}$/;

/** Zipcode may only contain letters and digits. */
export const CUSTOMER_ZIPCODE_PATTERN = /[A-Za-z0-9]+/;

export const CUSTOMER_NAME_MAX_LENGTH = 100;

/**
 * Deliberately larger than the 14 characters of `(XXX) XXX-XXXX`: a field saturated to its
 * maxlength silently rejects insertions, so an autofilled formatted number could not be edited
 * until a character was deleted first. The exact format is still enforced by the pattern.
 */
export const CUSTOMER_PHONE_MAX_LENGTH = 16;

export const CUSTOMER_EMAIL_MAX_LENGTH = 50;

export const CUSTOMER_STREET_ADDRESS_MAX_LENGTH = 150;

export const CUSTOMER_ZIPCODE_MIN_LENGTH = 3;

export const CUSTOMER_ZIPCODE_MAX_LENGTH = 5;

export const CONTRACTED_CUSTOMER_OPTIONS: DsRadioGroupOption[] = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const ADDRESS_VISIBILITY_OPTIONS: DsRadioGroupOption[] = [
  { value: false, label: 'Private' },
  { value: true, label: 'Public' },
];
